import React from 'react';
import { motion } from 'framer-motion';
import { BellRingIcon, LandmarkIcon, CheckCheckIcon } from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
const actions = [{
  icon: BellRingIcon,
  title: 'Send nudge',
  body: 'A polite reminder, so you never have to write that message yourself.'
}, {
  icon: LandmarkIcon,
  title: 'Share bank details',
  body: 'Optionally send your details when you want them to pay you back.'
}, {
  icon: CheckCheckIcon,
  title: 'Mark as paid',
  body: 'They pay you directly, mark it off, and you confirm it landed.'
}];
export function WhoOwesWhom() {
  return <section className="relative overflow-hidden bg-gray-950 py-20 text-white lg:py-28" data-id="element-351" data-mp="iob8ki0h9ao4">
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(circle_at_75%_30%,rgba(249,226,52,0.06),transparent_55%)]" data-id="element-352" data-mp="1q24tg2nz7sa3" />

      <div className="relative mx-auto max-w-7xl px-6 sm:px-8" data-id="element-353" data-mp="1u25azw6dgjld">
        <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-354" data-mp="20horsiiczh2y">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-6" data-id="element-355" data-mp="1vilk0qazuwra">
            <h2 className="mb-5 text-3xl font-black leading-[1.05] tracking-tight md:text-4xl lg:text-5xl" data-id="element-356" data-mp="1mhe0jed500h9">
              No mystery maths.
            </h2>
            <p className="mb-10 max-w-md text-lg leading-relaxed text-gray-400 lg:text-xl" data-id="element-357" data-mp="1crklg3dsd389">
              See exactly why someone owes you, expense by expense.
            </p>

            <ul className="space-y-5" data-id="element-358" data-mp="12ty4lbcxf1ln">
              {actions.map(action => <li key={action.title} className="flex gap-4" data-id="element-359" data-mp="12rts450you9r">
                  <span className="mt-0.5 flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-white/[0.08]" data-id="element-360" data-mp="yrjm4sd663uw">
                    <action.icon className="h-5 w-5 text-kitty-yellow" aria-hidden="true" data-id="element-361" data-mp="tvcf0w91embd" />
                  </span>
                  <div data-id="element-362" data-mp="o8aj9muzlr17">
                    <h3 className="mb-1 text-lg font-extrabold" data-id="element-363" data-mp="o4ms2ud0lgpn">
                      {action.title}
                    </h3>
                    <p className="text-base leading-relaxed text-gray-400" data-id="element-364" data-mp="f5rir9eobqi4">
                      {action.body}
                    </p>
                  </div>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="mx-auto w-full max-w-[340px] lg:col-span-6 lg:max-w-[380px]" data-id="element-365" data-mp="17uf9vlm3ta3l">
            <PhoneFrame screen={screens.breakdown} shadow="xl" data-id="element-366" data-mp="1lswvndsg8civ" />
          </motion.div>
        </div>
      </div>
    </section>;
}